import { render, staticRenderFns } from "./ListCarorders.vue?vue&type=template&id=01fbe876&scoped=true&"
import script from "./ListCarorders.vue?vue&type=script&lang=ts&"
export * from "./ListCarorders.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fbe876",
  null
  
)

export default component.exports